export const extractDownloadUrl = jsonLd => {
  if (jsonLd['atlassian:downloadUrl']) {
    return jsonLd['atlassian:downloadUrl'];
  }
};